<template>
	<m-drawer
		:title="$t('Commons.pleaseChoiceLikeLanguage')"
		:show.sync="showDrawer"
		:show-footer="true"
	>
		<div slot="content" class="m-lang-drawer">
			<div
				v-if="showDrawer"
				class="m-lang-list"
				:class="{
					'select-lang': select.code === it.code
				}"
				v-for="(it, index) in languageList"
				:key="index"
				@click="selectLanguage(it)"
			>
				<span>{{ it.name }}</span>
			</div>
		</div>
		<div slot="footer">
			<el-button class="!h-40 w-full" type="primary" @click="confirm">
				<span>{{ $t('Commons.confirm') }}</span>
			</el-button>
		</div>
	</m-drawer>
</template>

<script>
import mDrawer from '@/components/mobile/base/m-drawer.vue'
import { mapGetters, mapState } from 'vuex'

export default {
	components: {
		mDrawer
	},
	props: {
		visible: Boolean
	},
	data() {
		return {
			showDrawer: false,
			select: {}
		}
	},
	computed: {
		...mapState(['languageList']),
		...mapGetters(['language'])
	},
	watch: {
		visible(n, o) {
			if (n !== o && n !== this.showDrawer) {
				this.showDrawer = n
			}
		},
		showDrawer(n, o) {
			if (n !== o && n !== this.visible) {
				this.$emit('update:visible', n)
			}
			if (n) {
				this.select = this.languageList.find(it => it.value === this.language)
			}
		}
	},
	methods: {
		selectLanguage(it) {
			this.select = it
		},
		confirm() {
			this.showDrawer = false
			this.$emit('handleSetLanguage', this.select)
			this.$emit('confirm')
		}
	}
}
</script>

<style lang="scss" scoped>
.m-lang-drawer {
	padding: 0;
	.m-lang-list {
		padding: 18px 0;
		height: auto;
		background: theme('colors.bgColor.component');
		span {
			font-family: theme('fontFamily.pingFang');
			font-size: 14px;
			color: theme('colors.text.regular');
			line-height: 18px;
			font-weight: 400;
		}
	}
	.select-lang {
		background: theme('colors.bgColor.module');
		box-shadow: 0px 0px 10px theme('colors.primary');
	}
}
</style>
